import { Terminal } from 'lucide-react';

interface TerminalLoaderProps {
 text?: string;
}

export function TerminalLoader({
 text = 'SYSTEM_INITIALIZING...',
}: TerminalLoaderProps) {
 return (
  <div className='fixed inset-0 z-50 flex flex-col items-center justify-center bg-black overflow-hidden'>
   {/* Grid Background */}
   <div className='absolute inset-0 grid grid-cols-[repeat(20,minmax(0,1fr))] opacity-10 pointer-events-none'>
    {Array.from({ length: 400 }).map((_, i) => (
     <div key={i} className='border-[0.5px] border-primary/20' />
    ))}
   </div>

   <div className='z-10 bg-black/80 p-12 border border-primary/30 backdrop-blur-sm flex flex-col items-center gap-8 max-w-md w-full relative'>
    {/* Corner Accents */}
    <div className='absolute top-0 left-0 w-3 h-3 border-t border-l border-primary' />
    <div className='absolute top-0 right-0 w-3 h-3 border-t border-r border-primary' />
    <div className='absolute bottom-0 left-0 w-3 h-3 border-b border-l border-primary' />
    <div className='absolute bottom-0 right-0 w-3 h-3 border-b border-r border-primary' />

    {/* Central Icon */}
    <div className='relative'>
     <div className='absolute inset-0 bg-primary/20 blur-xl rounded-full animate-pulse' />
     <div className='w-20 h-20 border border-primary bg-black flex items-center justify-center relative overflow-hidden'>
      <div className='absolute inset-0 bg-primary/10 animate-[ping_3s_ease-in-out_infinite]' />
      <Terminal className='w-10 h-10 text-primary relative z-10' />
     </div>
    </div>

    {/* Status Text */}
    <div className='text-center space-y-2 w-full max-w-full overflow-hidden px-4'>
     <h2 className='font-mono text-xl text-primary font-bold tracking-[0.2em] animate-pulse whitespace-normal break-words'>
      {text}
     </h2>

     {/* Progress Bar */}
     <div className='h-1 w-full bg-primary/10 mt-4 overflow-hidden'>
      <div className='h-full bg-primary animate-[progress_2s_ease-in-out_infinite] w-1/3' />
     </div>

     <div className='font-mono text-[10px] text-primary/60 flex justify-between pt-2 uppercase'>
      <span>Cpu: OPTIMAL</span>
      <span>Mem: ALLOCATED</span>
     </div>
    </div>
   </div>
  </div>
 );
}
